module.exports = __webpack_public_path__ + "img/gastrorankingIcon.e63b49f7.svg";